import { cva } from 'class-variance-authority';

/**
 * Styles for ResetPasswordForm component
 * Uses responsive CSS classes instead of JavaScript conditionals
 * Follows same pattern as RecoverPasswordForm
 */
export const resetPasswordFormStyles = cva(
  [
    'auth-welcome',
    'w-full',
    // Vertical inset matches MFA steps: ForgotPasswordContainer supplies mt/mb on mobile & tablet;
    // do not stack pt-8 here (RecoverPassword personal-info has no outer margin, so it uses pt-8).
    'flex',
    'flex-col',
    'gap-0',
    'pt-0',
    'pb-0',
    'px-4',
    'md:gap-8',
    'md:items-center',
    'md:pt-0',
    'md:pb-8',
    'md:px-0',
    'lg:pt-0',
    'lg:pb-16',
    // Desktop: explicit 64px top + bottom (forgot-email .auth-welcome uses margin: 0 auto at lg, which
    // drops the file-level 64px top; MFA uses lg:mt-16/lg:mb-16 on the screen wrapper).
    'lg:!mt-16',
    'lg:!mb-16',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

/**
 * Container for form content (header, fields, buttons)
 * Responsive styling via CSS
 */
export const resetPasswordFormContentStyles = cva(
  [
    'w-full',
    // Mobile: no card wrapper
    // Tablet: card wrapper starts
    'md:auth-card',
    'md:bg-white',
    'md:rounded-2xl',
    'md:shadow-md',
    'md:py-8',
    'md:px-6',
    'md:max-w-[396px]',
    // Desktop: larger card
    'lg:px-8',
    'lg:max-w-[476px]',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

/**
 * Button group styles - responsive via CSS
 * Mobile: Update Password first, Cancel second (flex-col, stacked)
 * Tablet: Update Password first, Cancel second (flex-col, stacked)
 * Desktop: Cancel first, Update Password second (flex-row-reverse, horizontal)
 */
export const resetPasswordFormButtonGroupStyles = cva(
  [
    'flex',
    'flex-col', // Mobile and Tablet: vertical stack, Update Password first, Cancel second
    'gap-4', // Mobile and Tablet: 16px gap between buttons
    '!mt-8', // 32px margin-top from password requirements (mobile, tablet, desktop)
    // Desktop: horizontal layout reversed (Cancel first, Update Password second)
    'lg:flex-row-reverse',
    'lg:gap-4', // Desktop: 16px gap between buttons
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

/**
 * Error banner container - responsive margin and width matching card
 */
export const resetPasswordFormErrorStyles = cva(
  [
    'mt-6',
    'w-full',
    // Tablet: match card width (396px)
    'md:mt-4',
    'md:max-w-[396px]',
    // Desktop: match card width (476px)
    'lg:max-w-[476px]',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
